import { api } from '@/shared/redux/api/_generated/api/offboarding-api.generated';

export const offboardingApi = api.enhanceEndpoints({
  addTagTypes: ['Offboarding'],
  endpoints: {
    CreateOffboarding: {
      invalidatesTags: ['Offboarding'],
    },
    ReadOffboarding: {
      providesTags: ['Offboarding'],
    },
    DeleteOffboarding: {
      invalidatesTags: ['Offboarding'],
    },
  },
});

export const {
  useCreateOffboardingMutation,
  useReadOffboardingQuery,
  useDeleteOffboardingMutation,
} = offboardingApi;
